import React, { useState } from 'react'
import {
  ButtonCsvGenerate,
  ButtonCsvGenerateText,
  OptionContainer,
  OptionCounterparty,
  StackContainer
} from './Reports.style'
import { Box, CircularProgress, Typography } from '@mui/material'
import {
  AutocompleteStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../components/ModalApp/ModalApp.style'
import PaperAutoComplete from '../../components/PaperAutoComplete/PaperAutoComplete'
import { Label } from '../../components/styled/global.style'
import useAxios from '../../hooks/useAxios'
import { routes } from '../../utils/constants'
import { cleanEmptyField, downlandExcelTrades } from '../../helper'
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as DownloadReportIcon } from '../../assets/download_report.svg'

const Reports = () => {
  const [form, setForm] = useState({
    date_start: '',
    date_end: '',
    counterparty: '',
    trade_type: ''
  })
  const [submitLoader, setSubmitLoader] = useState(false)
  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)
  const { response: tradeTypes } = useAxios({ endPoint: routes.tradeType })
  const { response: counterparty } = useAxios({ endPoint: routes.counterParty })

  const handelFormChange = (event, element) => {
    const { name, value } = event.target
    const copyForm = { ...form }
    if (['date_start', 'date_end'].includes(name)) {
      copyForm[name] = value
    } else if (['counterparty', 'trade_type'].includes(name)) {
      if (name === 'counterparty') {
        copyForm[name] = element.split(' ').slice(0, -1).join(' ')
      } else {
        copyForm[name] = element
      }
    }
    setForm(copyForm)
  }

  const disableSubmit = () => {
    return Object.values(form).every(val => val === '')
  }

  const handelSubmit = async () => {
    const copyForm = { ...form }
    cleanEmptyField(copyForm)
    setSubmitLoader(true)
    await downlandExcelTrades(dispatch, token, '', copyForm, 'trade report.csv', routes.tradeReport)
    setSubmitLoader(false)
  }

  return (
    <StackContainer>
      Generate Report
      <Box>
        <Label>Date Start</Label>
        <TextFieldStyle
          type="date"
          name="date_start"
          value={form.date_start}
          onChange={handelFormChange}
        />
      </Box>
      <Box>
        <Label>Date End</Label>
        <TextFieldStyle
          type="date"
          name="date_end"
          value={form.date_end}
          onChange={handelFormChange}
        />
      </Box>
      <Box>
        <Label>Counterparty</Label>
        {Array.isArray(counterparty.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'counterparty'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.counterparty}
            getOptionLabel={option => option}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            options={counterparty.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth autoFocus placeholder="Select Client" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box>
        <Label>Trade Type</Label>
        {Array.isArray(tradeTypes.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'trade_type'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.trade_type}
            getOptionLabel={option => option}
            options={tradeTypes.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth autoFocus placeholder="Select Client" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      {!submitLoader ? (
        <ButtonCsvGenerate disabled={disableSubmit()} onClick={handelSubmit}>
          <>
            <ButtonCsvGenerateText>Generate CSV</ButtonCsvGenerateText>
            <DownloadReportIcon style={{ marginLeft: '8px' }} />
          </>
        </ButtonCsvGenerate>
      ) : (
        <Box style={{ width: '175px', textAlign: 'center' }}>
          <CircularProgress
            style={{
              marginTop: '35px',
              color: '#A4A4FF',
              height: '16px',
              width: '16px'
            }}
          />
        </Box>
      )}
    </StackContainer>
  )
}

export default Reports
